import React from 'react'
import {
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CheckCircle } from '@material-ui/icons'

const benefits = [
  '30% off an unlimited free delivery subscription',
  'Exclusive coupon offers on individual orders',
  '$0 delivery on group orders',
]

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: theme.breakpoints.width('md'),
    paddingTop: theme.spacing(4),
  },
  gridItem: {
    padding: theme.spacing(2),
  },
  logoImage: {
    maxHeight: '40px',
  },
  promoImage: {
    width: '75%',
    marginLeft: theme.spacing(2),
  },
  listItem: {
    padding: '6px 0',
  },
  listIcon: {
    minWidth: 'auto',
    marginRight: '8px',
  },
  checkIcon: {
    color: theme.palette.primary.main,
  },
}))

const PromoCreateTeam = ({ onCreateTeam }) => {
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <Box textAlign="center" marginBottom={5}>
        <img
          alt="Foodsby Logo"
          title="Foodsby Logo"
          src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/logo-foodsby.png`}
          className={classes.logoImage}
        />
      </Box>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.gridItem}>
          <Box mb={2}>
            <Typography variant="h4">Set your team up on Foodsby</Typography>
          </Box>

          <Typography variant="body1">
            Lunchtime is something you look forward to on a busy day at the office. Make it even
            better by adding your team. People who join get:
          </Typography>
          <Box marginY={3}>
            <List className={classes.list}>
              {benefits?.map((benefit, key) => (
                <ListItem key={key} className={classes.listItem}>
                  <ListItemIcon className={classes.listIcon}>
                    <CheckCircle className={classes.checkIcon} />
                  </ListItemIcon>
                  <ListItemText primary={benefit} />
                </ListItem>
              ))}
            </List>
          </Box>
          <Button color="primary" variant="contained" onClick={onCreateTeam}>
            Create a new team
          </Button>
        </Grid>
        <Hidden smDown>
          <Grid item md={6} className={classes.gridItem}>
            <img
              alt="Create a new team"
              src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/teams-promo.png`}
              className={classes.promoImage}
            />
          </Grid>
        </Hidden>
      </Grid>
    </Container>
  )
}

export default PromoCreateTeam
